var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './mobile-sports-filter.css';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { sportsbookFilter } from '../../store/sportsbook.store';
import { generateCompetitionGroupList } from '../../services/sportsbook.services';
import { useTranslation } from "react-i18next";
function buildDateTabs() {
    var tabs = [{ label: 'All', value: 'all' }];
    var today = new Date();
    for (var i = 0; i < 8; i++) {
        var d = new Date(today);
        d.setDate(today.getDate() + i);
        var value = d.toISOString().substring(0, 10);
        var label = void 0;
        if (i === 0)
            label = 'Today';
        else if (i === 1)
            label = 'Tomorrow';
        else
            label = "".concat(String(d.getDate()).padStart(2, '0'), "/").concat(String(d.getMonth() + 1).padStart(2, '0'));
        tabs.push({ label: label, value: value });
    }
    return tabs;
}
export default function MobileSportsFilter(_a) {
    var _b;
    var shownSportsBook = _a.shownSportsBook, onFilterChange = _a.onFilterChange;
    var params = useParams();
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var trackRef = useRef(null);
    var searchRef = useRef(null);
    var isLive = params.eventType === 'canli';
    var hasCompetition = !!params.competitionId;
    var sportSlug = params.sportSlug === 'tumu' ? 'futbol' : ((_b = params.sportSlug) !== null && _b !== void 0 ? _b : 'futbol');
    var _d = useState(isLive || hasCompetition ? 'league' : 'date'), selectedType = _d[0], setSelectedType = _d[1];
    var _e = useState('all'), selectedDate = _e[0], setSelectedDate = _e[1];
    var _f = useState(null), selectedLeague = _f[0], setSelectedLeague = _f[1];
    var _g = useState(false), searchOpen = _g[0], setSearchOpen = _g[1];
    var _h = useState(''), keyword = _h[0], setKeyword = _h[1];
    var _j = useState([]), leagueGroups = _j[0], setLeagueGroups = _j[1];
    useEffect(function () {
        var next = isLive || hasCompetition ? 'league' : 'date';
        setSelectedType(next);
        setSelectedLeague(null);
        setSelectedDate('all');
        sportsbookFilter.filterDays = [];
        if (!hasCompetition)
            sportsbookFilter.filterCompetition = [];
    }, [params.eventType, params.competitionId, params.sportSlug]);
    useEffect(function () {
        if (selectedLeague !== null)
            return;
        if (selectedType === 'league' && shownSportsBook.length > 0) {
            setLeagueGroups(generateCompetitionGroupList(shownSportsBook));
        }
    }, [shownSportsBook, selectedType, params.eventType, params.competitionId, params.sportSlug]);
    useEffect(function () {
        var _a;
        if (searchOpen)
            (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [searchOpen]);
    var dateTabs = buildDateTabs();
    var handleSearchToggle = function () {
        if (searchOpen) {
            setKeyword('');
            sportsbookFilter.filterKeyword = '';
            onFilterChange();
        }
        setSearchOpen(function (s) { return !s; });
    };
    var handleKeywordChange = function (value) {
        setKeyword(value);
        sportsbookFilter.filterKeyword = value;
        onFilterChange();
    };
    var handleDateClick = function (value) {
        setSelectedDate(value);
        sportsbookFilter.filterDays = value === 'all' ? [] : [value];
        onFilterChange();
    };
    var handleLeagueClick = function (groupName) {
        var _a, _b;
        setSelectedLeague(groupName);
        if (!groupName) {
            sportsbookFilter.filterCompetition = hasCompetition
                ? __spreadArray([], ((_b = (_a = params.competitionId) === null || _a === void 0 ? void 0 : _a.split(',')) !== null && _b !== void 0 ? _b : []), true) : [];
        }
        else {
            var group = leagueGroups.find(function (g) { return g.competitionGroupName === groupName; });
            if (group) {
                var ids = Object.values(group.competitions)
                    .flat()
                    .map(function (e) { var _a; return (_a = e.cId) === null || _a === void 0 ? void 0 : _a.toString(); })
                    .filter(Boolean);
                sportsbookFilter.filterCompetition = Array.from(new Set(ids));
            }
        }
        onFilterChange();
    };
    return (_jsxs("div", __assign({ className: "msf-bar" }, { children: [_jsx("button", __assign({ className: "msf-search-btn", onClick: handleSearchToggle, "aria-label": "Search" }, { children: _jsx("i", { className: searchOpen ? 'bc-i-close-remove' : 'bc-i-search' }, void 0) }), void 0), searchOpen ? (_jsx("input", { ref: searchRef, className: "msf-search-input", placeholder: "Search team or league\u2026", value: keyword, onChange: function (e) { return handleKeywordChange(e.target.value); } }, void 0)) : (_jsx("div", __assign({ className: "msf-track", ref: trackRef }, { children: selectedType === 'league' ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "msf-pill".concat(!selectedLeague ? ' msf-pill-active' : ''), onClick: function () { return handleLeagueClick(null); } }, { children: "ALL" }), void 0), leagueGroups.map(function (group) {
                            var _a;
                            return (_jsxs("div", __assign({ className: "msf-pill msf-pill-has-icon".concat(selectedLeague === group.competitionGroupName ? ' msf-pill-active' : ''), onClick: function () { return handleLeagueClick(group.competitionGroupName); } }, { children: [_jsx("i", { className: "flag-bc msf-flag ".concat((_a = group.countryName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) }, void 0), _jsx("span", { children: group.competitionGroupName }, void 0)] }), group.competitionGroupName));
                        })] }, void 0)) : (dateTabs.map(function (tab) { return (_jsx("div", __assign({ className: "msf-pill".concat(selectedDate === tab.value ? ' msf-pill-active' : ''), onClick: function () { return handleDateClick(tab.value); } }, { children: t("".concat(/\d/.test(tab.label) ? '' : 'general.').concat(tab.label.toLowerCase())) }), tab.value)); })) }), void 0))] }), void 0));
}
